<template>
    <section>
        <AdsComponent />
        <div class="videos">
            <!-- <div class="highlight videos_player" v-if="activeVideo" @click="close($event)" ref="video">
                <VideoComponent :video="activeVideo" class="videos_latest" :autoplay="true"/>
            </div> -->
            <div class="preview">
                <div class="preview_items">
                    <router-link class="preview_item" v-for="video, index in videosToDisplay" :key="video.id"
                        @click="activeVideoIndex = index + videosIndex * 4"
                        :to="{name: 'home_video', params: {video_id: video.slug} }">
                        <div class="preview_image">
                            <img :src="video.thumbnail_url" alt="" class="thumb">
                            <img src="@/assets/images/play_button.svg" alt="" class="play_button">
                        </div>
                        <h3 v-html="video.title.rendered"></h3>
                    </router-link>
                </div>

                <SliderButtons :currentSlide="videosIndex"
                :nrOfSlides="Math.ceil(videos.length / 4)"
                v-if="videos.length"
                class="preview_buttons"
                @update:currentSlide="videosIndex = $event" />

            </div>
            <WidgetOne class="ad2" :square="true"/>
        </div>
    </section>
</template>

<script>
import AdsComponent from './Ads.vue';
import SliderButtons from '@/components/Slider/Buttons.vue';
// import VideoComponent from '@/components/VideoComponent.vue';
import WidgetOne from './WidgetOne.vue';

export default {
    name: 'VideosComponent',
    components: {
        AdsComponent,
        SliderButtons,
        // VideoComponent,
        WidgetOne,
    },
    props: {
    },
    data() {
        return {
            play: false,
            activeVideoIndex: -1,
            videosIndex: 0,
            playing: false,
        }
    },
    methods: {
        start() {
            this.play = true
        },
        pause() {
            this.play = false
        },
    },
    computed: {
        activeVideo() {
            if( this.videos.length == 0 ) {
                return null
            }
            if( this.activeVideoIndex < 0 ) {
                return null
            }
            return this.videos[this.activeVideoIndex]
        },
        latestVideo() {
            if(this.videos.length == 0) {
                return null
            }
            return this.videos[0]
        },
        videos() {
            return this.$store.state.videos.all
        },
        videoSrc() {
            if(this.latestVideo == null) {
                return null
            }
            return `https://www.youtube.com/embed/${this.latestVideo.video_id}`
        },
        videosToDisplay() {
            const position = this.videosIndex * 4
            return this.videos.slice(position, position + 4)
        },
    },
    mounted() {
        this.$store.dispatch('videos/getAll')
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/queries";
@import "@/assets/scss/fonts";

section {
  --section-padding: 2rem var(--side-padding);
  --section-gap: 2rem;
  --videos-columns: 1fr;
  --videos-height: auto;
  --section-videos-gap: calc( var(--content-width) * .01);
  --section-videos-preview-margin: 0 0 2rem;
  background-image: url('../assets/videos-bg.png');
  background-size: cover;
  padding: var(--section-padding);
  max-width: 100%;
  row-gap: var(--section-gap);

  @include media(xl) {
    --section-padding: 8rem var(--side-padding);
    --section-gap: 4rem;
    --videos-columns: 5fr 4fr;
    --videos-height: calc( ( 100vw - 2 * var(--side-padding) ) * 0.3 );
    --section-videos-preview-margin: 0;
  }

  .ad1 {
    width: 100%;
  }

  .videos {
    display: grid;
    align-items: center;
    margin-top: 2rem;

    height: var(--videos-height);
    grid-template-columns: var(--videos-columns);
    gap: var(--section-videos-gap);


    &_player, &_latest {
      width: 100%;
    }

    &_latest {
        width: var(--content-width);
        pointer-events: all;
    }

  }

  .preview {
    flex-basis: 0;
    object-fit: contain;
    width: 100%;
    height: fit-content;
    margin: var(--section-videos-preview-margin);
    display: flex;
    position: relative;
    min-width: 30vw;
    z-index: 5;

    &_buttons {
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      width: fit-content;
      bottom: -1rem;
    }

    &_image {
      width: 100%;
      height: 0;
      padding: calc(9 / 16 * 100%) 0 0;
      position: relative;
      margin: 0 0 .5rem;

      .thumb, .play_button {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
      }

      .thumb {
        object-fit: cover;
      }

      .play_button {
        max-height: 80%;
        max-width: 50%;
        margin: auto;
        object-fit: contain;
        opacity: .5;
        transition: opacity .2s ease-out;
      }
    }

    &_items {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
      width: 100%;
      min-height: 0;
      margin: auto;
    }

    &_item {
      height: 100%;
      width: 100%;
      cursor: pointer;
      text-decoration: none;

      &:hover {
          .play_button {
              opacity: 1;
          }
      }

      h3 {
        color: white;
        font-size: .75rem;
        font-family: $ff-headings;
        font-weight: normal;
      }
    }
  }

  .ad2 {
    object-fit: contain;
    margin: 0 0 0 auto;
    height: 100%;
    min-height: 0;
    flex-grow: 1;
  }
}
</style>
